<div class="circular-container">
  <svg class="progress-ring" width="40" height="40">
    <circle
      class="progress-ring__background"
      stroke="#d3d4d6"
      stroke-width="3"
      fill="transparent"
      r="16"
      cx="20"
      cy="20"
    />
    <circle
      class="progress-ring__circle"
      [attr.stroke-dasharray]="314"
      [attr.stroke-dashoffset]="314 - (progressPercent / 100) * 314"
      stroke="#2e7d32"
      stroke-width="3"
      fill="transparent"
      r="16"
      cx="20"
      cy="20"
      stroke-linecap="round"
    />
  </svg>
</div>
